import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import _ from "underscore";
import './style.scss'
import './reviewGroup.scss'

import PageTitle from "../../../components/common/PageTitle";
import ModalProductList from "../../../components/modal/ModalProductList";
import ModalLoading from "../../../components/common/ModalLoading";

import {
  FormInput,
  Button
} from "shards-react";
import FeatherIcon from 'feather-icons-react';
// import Calendar from "react-calendar";
// import DateTimePicker from 'react-datetime-picker';
// import axios from "axios";


@inject(({ common }) => ({ getUploadUrl: common.getUploadUrl, uploadImg: common.uploadImg, getDoc: common.getDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ product }) => ({ getProductGroupList: product.getProductGroupList, updateProductGroup: product.updateProductGroup, removeProductGroup: product.removeProductGroup}))
@inject(({ review }) => ({ updateReview:review.updateReview }))

@observer
class ReviewGroup extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {};
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = false;
  @observable urlParams = new URLSearchParams(window.location.search);

  //list
  @observable grouplistParams = {
    page:1, limit:200,
  }
  // @observable searchParams = {
  //   keyword: ''
  // };
  @observable groupList = [];


  //modals
  @observable modals = {
    ModalProductList: false,
    ModalChildProductList: false
  };

  @observable dropDowns = {
    type: false
  };

  //page

  @observable newGroup = {
    store_id: '',
    type: 'share',
    parentProduct_ids: [],
    childProduct_ids: [],
    product_ids: [],
    products: [],
    name: ''
  };
  @observable added_ids = [];
  @observable  parentGroupProducts = [];

  @observable selGroup = {};
  @observable isUse = false;
  @observable newGroupError = '';
  @observable editingNameId = null;
  @observable draftName = '';

  constructor(props) {
    super(props);
    this.typeStr = {
      share: '공유형',
      // integration: '통합형'
    };
    this.init();

    this.modalToggle = this.modalToggle.bind(this);
  }


  componentDidUpdate(prevProps, prevState) {

  }

  @action
  init = async (key) => {
    if(this.props.isLogin) {
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.permissions = this.props.me.permissions;

      this.newGroup.store_id = this.teamUser.selStore_id;
      this.newGroup.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo :1;
      this.selGroup.store_id = this.teamUser.selStore_id;
      this.selGroup.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo :1;
      this.grouplistParams.store_id = this.teamUser.selStore_id;
      this.grouplistParams.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo :1;
      this.getProductGroupList();

      this.isUse = false;
      if(this.teamUser.hasReviewWriteAddon) {
        this.isUse = true;
      }

    }

  };

  getProductGroupList = async() => {
    if(this.grouplistParams.store_id) {
      this.groupList = await this.props.getProductGroupList(this.grouplistParams);
      this.isLoading = false;
    }
    else {
      //console.log('null store_id');
    }
  };

  //fn


  onChangeValue = async (event) => {
    const { name, value } = event.target;
    this.newGroup[name] = value;
    this.newGroup.isEdit = true;
  };

  setGroup = async (list, ids) => {
    this.selGroup.products = list;
  };

  addGroup = async() => {

    if(!this.isUse) {
      alert('유료회원 전용 기능입니다.');
      return false;
    }

    if(this.groupList.docs && this.groupList.docs.length > 0) {
      for (let obj of this.groupList.docs) {
        if (obj.isEdit) {
          let isConfirm = window.confirm("'" + obj.name + "' 그룹이 선택되어 있습니다. 해당 그룹을 저장하시겠습니까?");
          if (isConfirm) {
            await this.saveGroup();
          }
          obj.isEdit = false;
        }
      }
    }
    //this.newGroup to this.selGroup에 copy data
    if(!this.newGroup.name || !this.newGroup.name.trim()) {
      this.newGroupError = '그룹 이름을 입력해주세요.';
      return;
    }
    this.newGroupError = '';
    if(this.newGroup.name) {
      this.selGroup = Object.assign({}, this.newGroup);
      this.selGroup.isEdit = true;
      this.groupList.docs.push(this.selGroup);

      this.newGroup = {
        store_id: this.teamUser.selStore_id,
        shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo :1,
        type: 'share',
        parentProduct_ids: [],
        childProduct_ids: [],
        product_ids: [],
        products: [],
        name: ''
      };
      this.parentGroupProducts = [];
      this.added_ids = [];
    }
  };

  selectedGroup = async (item) => {
    if(this.groupList.docs && this.groupList.docs.length > 0) {
      for (let obj of this.groupList.docs) {
        if (obj.isEdit) {
          let isConfirm = window.confirm("'" + obj.name + "' 그룹이 선택되어 있습니다. 해당 그룹을 저장하시겠습니까?");
          if (isConfirm) {
            await this.saveGroup();
          }
          obj.isEdit = false;
        }
      }
    }


    item.products = item.product_ids;
    this.parentGroupProducts = item.parentProduct_ids;
    this.selGroup = item;
    this.selGroup.isEdit = true;
    let product_ids = _.pluck(item.product_ids, '_id');
    let childGroupProduct_ids = _.pluck(item.parentProduct_ids, '_id');
    this.added_ids = product_ids.concat(childGroupProduct_ids);
  };

  saveGroup = async () => {
    let saveGroup = Object.assign({}, this.selGroup);
    saveGroup.product_ids = this.selGroup.products.map(item => item._id);
    saveGroup.parentProduct_ids = this.parentGroupProducts.map(item => item._id);

    const res = await this.props.updateProductGroup(saveGroup);
    if (res.errors && res.errors.length > 0) {
      alert(res.errors[0].message);
    } else {
      // 원본 객체의 product_ids도 현재 상태로 업데이트
      this.selGroup.product_ids = this.selGroup.products;
      this.selGroup.parentProduct_ids = this.parentGroupProducts;
      this.selGroup.isEdit = false;
    }
  };

  revmoeGroup = async (item, i) => {
    if((item.id !== this.selGroup.id) && this.groupList.docs && this.groupList.docs.length > 0) {
      for (let obj of this.groupList.docs) {
        if (obj.isEdit) {
          let isConfirm = window.confirm("'" + obj.name + "' 그룹이 선택되어 있습니다. 해당 그룹을 저장하시겠습니까?");
          if (isConfirm) {
            await this.saveGroup();
          }
          obj.isEdit = false;
        }
      }
    }

    let isConfirm = window.confirm('"' + item.name + '" 그룹을 정말 삭제할까요?');
    if(isConfirm) {
      const res = this.props.removeProductGroup(item);
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        this.groupList.docs.splice(i, 1);
      }
    }
    else {
      return false;
    }

  };

  setParentGroup = async (list) => {
    this.parentGroupProducts = list;
  };

  removeProduct = async (target, item) => {
    if(target === 'product') {
      this.selGroup.products = _.reject(this.selGroup.products, function(obj) {
        return obj._id === item._id;
      });
    }
    else if(target === 'parent') {
      this.parentGroupProducts = _.reject(this.parentGroupProducts, function(obj) {
        return obj._id === item._id;
      });
    }

    this.added_ids = _.without(this.added_ids, item._id);
  };



  // addChildGroup = async() => {
  //   this.selGroup = this.newGroup;
  // };

  showModal = async(target) => {
    this.modals[target] = true;
  };
  @action
  modalToggle = async (target, isShow, data) => {
    if(isShow) {
      this.modals[target] = true;
    }
    else {
      this.modals[target] = !this.modals[target];
    }

    if(!target) {
      for( var i in this.modals) {
        this.modals[i] = false;
      }
    }
    if(data) {
      this.modals.data = data;
    }
  };

  dropDownToggle = async (target) => {
    if(target) {
      this.dropDowns[target] = !this.dropDowns[target];
    }
  };





  // 상품 _id 형식: {platform}_{store_id}_{[shopNo_]}{platformProductId}
  // 백엔드 populate 전(배포 전)에는 platformProductId 필드가 없어 _id 에서 파싱한다.
  buildProductUrl = (item) => {
    if(!item) return null;
    const store = this.store || {};
    let domain = store.domain || (store.platformId ? store.platformId + '.cafe24.com' : '');
    if(!domain) return null;
    let platformProductId = item.platformProductId;
    if(!platformProductId && item._id) {
      const parts = String(item._id).split('_');
      platformProductId = parts[parts.length - 1];
    }
    if(!platformProductId) return null;
    const name = item.productName || item.name || platformProductId;
    const base = /^https?:\/\//.test(domain) ? domain : '//' + domain;
    return base + '/product/' + encodeURIComponent(name) + '/' + platformProductId + '/';
  };

  openProductPage = (item) => {
    const url = this.buildProductUrl(item);
    if(url) window.open(url, '_blank', 'noopener');
  };

  goGroupReviews = (group) => {
    if(!group || !group._id) return;
    const qs = '?group_id=' + encodeURIComponent(group._id) + '&name=' + encodeURIComponent(group.name || '');
    if(this.props.history) {
      this.props.history.push('/reviewGroupReviews' + qs);
    }
    else {
      window.location.href = '/reviewGroupReviews' + qs;
    }
  };

  renderProductCard = (item, target) => {
    const thumb = item.images && item.images.s_1 ? item.images.s_1 : '';
    const name = item.productName || item.name || '-';
    const url = this.buildProductUrl(item);
    return (
      <div key={item._id} className="rg-product-card">
        <div className={`rg-product-card__thumb${url ? ' is-clickable' : ''}`}
             onClick={url ? () => this.openProductPage(item) : undefined}
             title={url ? '상품 페이지 새 탭으로 열기' : undefined}>
          {thumb ? <img src={thumb} alt={name}/> : <span className="rg-product-card__noimg"><FeatherIcon icon="image" size="24"/></span>}
          <button type="button"
                  className="rg-product-card__remove"
                  title="상품 제거"
                  onClick={e => { e.stopPropagation(); this.removeProduct(target, item); }}>
            <FeatherIcon icon="x" size="14"/>
          </button>
        </div>
        <div className="rg-product-card__meta">
          <div className={`rg-product-card__name${url ? ' is-link' : ''}`}
               title={url ? name + ' (상품 페이지 열기)' : name}
               onClick={url ? () => this.openProductPage(item) : undefined}>{name}</div>
        </div>
      </div>
    );
  };

  renderAddCard = (target, modalKey) => (
    <div className="rg-product-card rg-product-card--add"
         onClick={() => this.modalToggle(modalKey, true)}>
      <div className="rg-product-card__add-inner">
        <FeatherIcon icon="plus" size="22"/>
        <span>상품 추가</span>
      </div>
    </div>
  );

  render() {
    const docs = (this.groupList && this.groupList.docs) || [];

    return (
      <div className="main-content rg-page">
        <PageTitle title="리뷰 그룹" subtitle="리뷰/답글" className="mb-4"/>

        {(this.isLogin && this.teamUser && !this.teamUser.hasReviewWriteAddon) && (
          <div className="es-paywall-banner">
            <FeatherIcon icon="lock" size="14"/>
            <span><strong>그룹 화면은 무료로 확인</strong>할 수 있습니다. 새 그룹 생성은 <strong>리뷰 부스터 추가 옵션</strong>이 필요합니다.</span>
            <button type="button" className="es-paywall-banner__cta"
                    onClick={() => { window.location.href = '/inAppOrder'; }}>
              <FeatherIcon icon="credit-card" size="13"/>
              결제페이지로 이동하기
              <FeatherIcon icon="arrow-right" size="13"/>
            </button>
          </div>
        )}

        {/* 상단: 안내 + 새 그룹 추가 */}
        <div className="widget-box">
          <div className="section-box">
            <div className="section-tit" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, padding: '16px 20px', borderBottom: '1px solid #F1F5F9'}}>
              <div style={{flex: 1}}>
                <h3 style={{margin: 0, fontSize: 15, fontWeight: 700, color: '#1F2937'}}>리뷰 그룹 관리</h3>
                <p style={{margin: '6px 0 0', fontSize: 13, color: '#6B7280', lineHeight: 1.5}}>
                  여러 상품을 하나의 그룹으로 묶어 <b>리뷰를 공유</b>할 수 있습니다. 같은 그룹에 속한 상품들은 서로의 리뷰를 함께 노출합니다.<br/>
                  <span style={{color: '#DC2626'}}>⚠ 고객 신뢰를 해칠 수 있는 무리한 통합은 피해주세요.</span>
                </p>
              </div>
              <div style={{display: 'flex', alignItems: 'flex-start', gap: 8, flexShrink: 0}}>
                <div style={{display: 'flex', flexDirection: 'column', gap: 2}}>
                  <FormInput
                    name="name"
                    placeholder="새 그룹 이름"
                    value={this.newGroup.name}
                    onChange={e => { this.onChangeValue(e); this.newGroupError = ''; }}
                    invalid={!!this.newGroupError}
                    style={{width: 220}}
                    onKeyPress={e => { if (e.key === 'Enter') { e.preventDefault(); this.addGroup(); } }}
                  />
                  {this.newGroupError && <span style={{color: '#DC2626', fontSize: 11}}>{this.newGroupError}</span>}
                </div>
                <Button theme="primary" onClick={() => this.addGroup()} style={{display: 'inline-flex', alignItems: 'center', gap: 4}}>
                  <FeatherIcon icon="plus" size="16"/> 그룹 추가
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* 그룹 리스트 */}
        {docs.length === 0 ? (
          <div className="src-empty-state" style={{marginTop: 20, background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 10}}>
            <FeatherIcon icon="layers" size="40"/>
            <div className="src-empty-state__title">등록된 리뷰 그룹이 없습니다</div>
            <div className="src-empty-state__desc">상단의 <b>그룹 추가</b>로 첫 그룹을 만들어 상품을 묶어보세요.</div>
          </div>
        ) : (
          docs.map((group, idx) => {
            const isOpen = !!group.isEdit;
            const products = (group.products || group.product_ids || []);
            const productCount = products.length;
            const isEditingName = this.editingNameId === group._id;
            return (
              <div key={group._id || idx} className={`src-group-card ${isOpen ? 'is-active' : ''}`}>
                <div className="src-group-card__head"
                     onClick={() => { if (!isEditingName) this.selectedGroup(group); }}>
                  <FeatherIcon icon="layers" size="16" style={{color: '#6B7280'}}/>
                  <div className="src-group-card__title-wrap">
                    {isEditingName ? (
                      <FormInput value={this.draftName}
                                 onClick={e => e.stopPropagation()}
                                 onChange={e => this.draftName = e.target.value}
                                 onKeyDown={e => {
                                   if (e.key === 'Enter') { group.name = this.draftName.trim() || group.name; group.isEdit = true; this.editingNameId = null; }
                                   if (e.key === 'Escape') { this.editingNameId = null; }
                                 }}
                                 style={{maxWidth: 240}}/>
                    ) : (
                      <>
                        <span className="src-group-card__title" title={group.name}>{group.name}</span>
                        <span className="src-group-card__name-edit"
                              title="그룹명 편집"
                              onClick={e => { e.stopPropagation(); this.editingNameId = group._id; this.draftName = group.name; }}>
                          <FeatherIcon icon="edit-2" size="12"/>
                        </span>
                      </>
                    )}
                  </div>
                  <div className="src-group-card__summary" onClick={e => e.stopPropagation()}>
                    <span className="src-chip">상품 {productCount}개</span>
                    {group._id && (
                      <Button size="sm" outline theme="primary" onClick={() => this.goGroupReviews(group)}>
                        <FeatherIcon icon="message-square" size="12"/> 리뷰 보기
                      </Button>
                    )}
                    {isOpen && group.isEdit && (
                      <Button size="sm" theme="primary" onClick={() => this.saveGroup()}>
                        <FeatherIcon icon="save" size="12"/> 저장
                      </Button>
                    )}
                    <Button size="sm" theme="danger" onClick={() => this.revmoeGroup(group, idx)}>
                      <FeatherIcon icon="trash-2" size="12"/> 삭제
                    </Button>
                  </div>
                  <span className="src-group-card__toggle">
                    <FeatherIcon icon={isOpen ? 'chevron-up' : 'chevron-down'} size="16"/>
                  </span>
                </div>

                {isOpen && (
                  <div className="src-group-card__body">
                    <div className="rg-product-grid">
                      {this.renderAddCard('product', 'ModalProductList')}
                      {(this.selGroup.products || []).map(p => this.renderProductCard(p, 'product'))}
                    </div>
                    {(!this.selGroup.products || this.selGroup.products.length === 0) && (
                      <div style={{marginTop: 12, fontSize: 12, color: '#9CA3AF'}}>
                        <FeatherIcon icon="info" size="12" style={{marginRight: 4, verticalAlign: 'middle'}}/>
                        상단의 <b>+ 상품 추가</b> 카드를 눌러 이 그룹에 포함할 상품을 선택하세요.
                      </div>
                    )}

                    {this.selGroup.type === 'integration' && (
                      <div style={{marginTop: 16, padding: 12, background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 8}}>
                        <div style={{fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6}}>
                          <FeatherIcon icon="download" size="14"/> 리뷰를 받아올 상위 상품
                        </div>
                        <div className="rg-product-grid">
                          {this.renderAddCard('parent', 'ModalChildProductList')}
                          {(this.parentGroupProducts || []).map(p => this.renderProductCard(p, 'parent'))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })
        )}

        <ModalProductList isShow={this.modals.ModalProductList} modal="ModalProductList" modalToggle={this.modalToggle} setGroup={this.setGroup} inGroup={this.selGroup.products} added_ids={this.added_ids}/>
        <ModalProductList isShow={this.modals.ModalChildProductList} modal="ModalChildProductList" modalToggle={this.modalToggle} setGroup={this.setParentGroup} inGroup={this.parentGroupProducts} added_ids={this.added_ids}/>
        <ModalLoading isLoading={this.isLoading} />
      </div>
    );
  }
}

export default ReviewGroup;
